module.exports = __webpack_public_path__ + "img/unlock.b38b0305.svg";